import BaseAPI from './base.api';
import {
  type StatusCodeRecord,
  type CreateStatusCodePayload,
  type UpdateStatusCodePayload,
  type CreateStatusCodeResult,
  type UpdateStatusCodeResult,
  type MakeModelRecord,
} from 'views/Settings/StatusCodes/types';

export default class StatusCodesAPI extends BaseAPI {
  getAll = async (): Promise<StatusCodeRecord[]> => {
    const response = await this.API.get('status-codes', {
      params: { customerId: this.customerId },
    });
    return Array.isArray(response.data) ? response.data : [];
  };

  create = async (
    payload: CreateStatusCodePayload
  ): Promise<CreateStatusCodeResult> => {
    const response = await this.API.post('status-codes', payload, {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  update = async (
    id: string,
    payload: UpdateStatusCodePayload
  ): Promise<UpdateStatusCodeResult> => {
    const response = await this.API.put(`status-codes/${id}`, payload, {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  remove = async (id: string): Promise<{ message: string }> => {
    const response = await this.API.delete(`status-codes/${id}`, {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  getMakeModels = async (): Promise<MakeModelRecord[]> => {
    const response = await this.API.get(
      `make-model-details/customer/${this.customerId}`
    );
    return Array.isArray(response.data)
      ? response.data.map(
          (item: { id: string; make: string; model: string }) => ({
            id: item.id,
            make: item.make,
            model: item.model,
          })
        )
      : [];
  };
}
